// Copyright (c) 2017 Deere & Company

import {
    deleteLayout,
    updateExistingLayout,
    updateLayoutModal
} from './update-layout-modal';
import {
    getReportLayouts,
    hideReportColumn,
    resetReportVariant,
    showReportColumn,
    updateDefaultLayout,
    updateGridLayouts,
    updateReportColumnsVisibility,
    updateReportProperty
} from './report-variant';
import {
    resetCreateLayoutModal,
    saveReportLayout,
    updateCreateLayoutModal
} from './create-layout-modal';
import {
    resetReportIsScrollable,
    toggleReportIsScrollable
} from './reset-report-is-scrollable';
import {createAgGridApi} from './create-ag-grid';
import {resetSearchResults} from './reset-search-results';
import {updateCriteriaValidity} from './criteria-validity';
import {updateShowNoResultsFound} from './show-no-results-found';

export const sharedActionCreators = {
    createAgGridApi,
    deleteLayout,
    getReportLayouts,
    hideReportColumn,
    resetCreateLayoutModal,
    resetReportIsScrollable,
    resetReportVariant,
    resetSearchResults,
    saveReportLayout,
    showReportColumn,
    toggleReportIsScrollable,
    updateCreateLayoutModal,
    updateCriteriaValidity,
    updateDefaultLayout,
    updateExistingLayout,
    updateGridLayouts,
    updateLayoutModal,
    updateReportColumnsVisibility,
    updateReportProperty,
    updateShowNoResultsFound
};



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/index.js